import React, { useState, useEffect } from 'react';
import './getpanverify.css';

const RepayLoan = () => {
  const [mobile, setMobile] = useState('');
  const [refStr, setRefStr] = useState('');
  const [responseMsg, setResponseMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('refstr');
    if (ref) {
      setRefStr(ref);
    }
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();

    try {
      // Build query string
      const apiUrl = `https://loanontip.in/Api/TaskApi/getLeadInfo?lead_id=${refStr}&pan_number=${mobile}`;

      const res = await fetch(apiUrl);
      const text = await res.text(); // API sometimes sends HTML/text, not always JSON
      console.log("API Response:", text);

      setResponseMsg(text); // display result in UI
    } catch (error) {
      console.error("Error fetching API:", error);
      setResponseMsg("Something went wrong while verifying PAN.");
    }
  };

  return (
    <div className="repay-loan-page">
      {/* Hero Section with PAN Verification Title */}
      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">PAN Verification</h1>
        </div>
      </section>

      {/* Input Field and Submit Button */}
      <section className="container mt-5">
        <form
          onSubmit={handleSearch}
          className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4"
        >
          <input
            type="text"
            className="form-control"
            placeholder="Enter Your PAN Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
          {/* hidden field for lead_id */}
          <input type="hidden" name="lead_id" value={refStr} />

          <button type="submit" className="btn custom-submit-btn">
            Submit
          </button>
        </form>

        {/* Show API response */}
        {responseMsg && (
          <div className="alert alert-info mt-3">
            <div dangerouslySetInnerHTML={{ __html: responseMsg }} />
          </div>
        )}
      </section>
    </div>
  );
};

export default RepayLoan;
